import * as types from './mutation-types'
import axios from 'axios'

var $http = axios.create({
  // Fake local json-server API
  // baseURL: 'http://localhost:3000'

  // Local ATOM API
  // baseURL: 'http://localhost:5100/api/v1'

  // Staging ATOM API
  // baseURL: 'http://beta.tungstenatom.com/api/v1'

  // Production ATOM API
  baseURL: 'https://app.tungstenatom.com/api/v1'
})

export const fetchQuoteTemplates = ({ commit, getters }) => {
  $http.defaults.headers.common['Authorization'] = `Token token=${getters.authToken}`

  $http.get('/quote_templates')
    .then((response) => {
      commit(types.SET_QUOTE_TEMPLATES, { quoteTemplates: response.data })
    })
    .catch((error) => {
      commit('SET_FLASH', {
        type: 'error',
        message: error.message
      })
    })
}

export const saveQuote = ({ commit, getters, state }) => {
  if (getters.isNewQuote) {
    $http.post('/quotes', state.quote)
      .then((response) => {
        commit(types.LOAD_QUOTE, { quote: response.data })
      })
      .catch((error) => {
        commit('SET_FLASH', {
          type: 'error',
          message: error.message
        })
      })
  } else {
    $http.patch(`/quotes/${state.quote.id}`, { payload: state.quote.payload })
      .then((response) => {
        commit(types.LOAD_QUOTE, { quote: response.data })
        commit(types.SET_QUOTE_SAVED)
      })
      .catch((error) => {
        commit('SET_FLASH', {
          type: 'error',
          message: error.message
        })
      })
  }
}

export const saveNewQuoteVersion = ({ commit, state }) => {
  $http.post('/quotes', state.quote)
    .then((response) => {
      commit(types.LOAD_QUOTE, { quote: response.data })
      commit(types.SET_FLASH, {
        type: 'success',
        message: `Successfully saved Version ${response.data.version} of the Quote.`
      })
      commit(types.SET_QUOTE_SAVED)
    })
    .catch((error) => {
      commit('SET_FLASH', {
        type: 'error',
        message: error.message
      })
    })
}

export const loadQuote = ({ commit, getters }, quoteId) => {
  $http.defaults.headers.common['Authorization'] = `Token token=${getters.authToken}`

  $http.get(`/quotes/${quoteId}`)
    .then((response) => {
      commit(types.LOAD_QUOTE, { quote: response.data })
      commit(types.SET_QUOTE_LOADED)
    })
    .catch((error) => {
      commit('SET_FLASH', {
        type: 'error',
        message: error.message
      })
    })
}



// WEBPACK FOOTER //
// ./src/store/actions.js